var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "m24.205 31.844 6.647-6.656 6.648 6.656 6.648-6.656 6.647 6.656-6.647 6.656 6.647 6.656-6.647 6.656-6.648-6.656-6.648 6.656-6.647-6.656 6.647-6.656z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M54.6 22.243a23 23 0 0 1 4.498 7.569M37.5 14.579c3.649 0 7.1.855 10.163 2.374"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    className: "stroke",
    d: "M10.339 50.247A29.86 29.86 0 0 1 7.5 37.5c0-16.557 13.443-30 30-30s30 13.443 30 30-13.443 30-30 30c-4.307 0-8.403-.91-12.107-2.547"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/error-circle.fb1154ad6834a1c141fb1852e962937a.svg";
export { ForwardRef as ReactComponent };